<template>
	<view
		class="nav_my_body" 
		:style="{
			display: data.displayNew,
			padding: '0',
			overflow: 'hidden',
			backgroundColor: 'unset',
	}">
	    <view class="nav_list" style="padding:0">
			<image 
			class="nav_icon"
			style="width: 100%; height: 100px;" 
			:src="fnReplaceSerImgUrl(data.middleImgUrl)" 
			@click="fnGotoMicroPage"
			></image>
	    </view>
	</view>
</template>

<script setup>
	import { onShow } from '@dcloudio/uni-app';
	import { getCurrentInstance, reactive, ref} from "vue";
	import { fnReplaceSerImgUrl } from "@/utils/utils.js";
	import { selDecorateHeaderSet } from '@/api/prod/prod.js';
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	
	// 页面显示时执行
	onShow(() => {
		// 获取页面装饰信息
		getPersonStyle();
	})
	
	// 页面数据
	const data = reactive({
		// 控制中间图片显示状态
		displayNew: "none",
		// 中间图片URL
		middleImgUrl: null,
		// 中间图链接类型 1微页面 2商城产品 3产品分类 4定位导航 5公众号文章 6联系我们 9文章类型
		linkType: null,
		// 中间图链接名称(商品名/分享链接/公众号文章)
		linkName: null,
		// 中间图链接商品id/链接页面id/公众号地址
		tsIdOrUrl: null,
	})
	
	// 获取图片信息
	function getPersonStyle() {
		// 获取平台ID，默认为1
		let platId = 1;
		if(ctx.vuex_platId != undefined && ctx.vuex_platId != null && ctx.vuex_platId != "") {
			platId = ctx.vuex_platId;
		}
		
		// 构造请求参数
		let paramObj = {
			platId: platId,
			shopId: platId,
			companyId: platId,
		};
		
		// 调用API获取装饰头部设置信息
		selDecorateHeaderSet(JSON.stringify(paramObj)).then(res => {
			if (res.retCode == 1) {
				// 设置中间图片URL
				data.middleImgUrl = res.obj.middleImgUrl;
				// 设置链接类型
				data.linkType = res.obj.linkType;
				// 设置链接名称
				data.linkName = res.obj.linkName;
				// 设置链接ID或URL
				data.tsIdOrUrl = res.obj.tsIdOrUrl;
				// 如果图片URL存在且不为空，则显示图片
				if(res.obj.middleImgUrl != null && res.obj.middleImgUrl != ""){
					data.displayNew = "block";
				}
			} else {
				console.log("请求错误");
			}
		}).catch(err => {
			uni.$u.toast(err.msg); 
		})
	}
	
	// 中间图片跳转处理
	function fnGotoMicroPage() {
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		console.log("登录状态" + ctx.vuex_hasLogin)
		// 首先需要判断是否已经登录
		let isLogin = ctx.vuex_hasLogin;
		if(isLogin) {
			// 链接所属分类 1 微页面 2 商城商品 3 商品分类 4 定位导航 5 公众号文章  6 联系我们  8 签到  9 文章分类
			let linkType = data.linkType;
			let tsIdOrUrl = data.tsIdOrUrl;
			console.log(linkType)
			if (linkType == 1) {
				// 跳转到微页面
				uni.navigateTo({
					url: '/pages/micro_page/micro_page?activityId=' + tsIdOrUrl,
				});
			} else if (linkType == 2) {
				// 跳转到商品详情页
				uni.navigateTo({
					url: '/pages/prod_detail/prod_detail?prodId=' + tsIdOrUrl,
				});
			} else if (linkType == 5) {
				// 跳转到公众号文章逻辑
				if(tsIdOrUrl != null && tsIdOrUrl != "" && tsIdOrUrl != undefined) {
					//var isWxCheck = wx.getStorageSync('memb').isWxCheck;
					//if(isWxCheck == 0){
					//let linkUrl = encodeURIComponent(tsIdOrUrl);
					//uni.navigateTo({
						//url: '/pages/out/out?linkUrl=' + linkUrl,
					//}); 
				  }
			} else if (linkType == 9) {
				// 跳转文章类型
				uni.navigateTo({
					url: '/pages/articleCard/articleCard',
				});
			} 
		}
	}
</script>

<style>
</style>